import { Row, Typography } from '@visa/vds';
import React, { useState } from 'react';

const AdminPackagesListFootnote = () => {
    const [toggle, setToggle] = useState(false);
    return (
        <>
            <a className="cursor-pointer text-decoration-none font-size-16px padding-bottom-5px" onClick={() => setToggle(!toggle)} >
                <span className="padding-left-2px">Footnotes</span>
            </a >
            {toggle &&
                <Row>
                    {"A blue filter icon in the table header indicates that a filter is active for that column."}
                </Row>
            }
        </>
    );
};

export default AdminPackagesListFootnote;